import {Component} from '@angular/core';
import {PwaInstallService} from '../../services/pwa-install.service';

@Component({
  selector: 'app-pwa-install-help',
  templateUrl: './pwa-install-help.component.html',
  styleUrls: ['./pwa-install-help.component.css']
})
export class PwaInstallHelpComponent {
  constructor(public installation: PwaInstallService) {}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/pwa/pwa-install-help.component.ts